 $(".feature-collection-slider").owlCarousel({
    items: 2,
    loop: !0,
    margin: 20,
    nav: !0,
    navText: ['<i class="fa-solid fa-arrow-left-long"></i>', '<i class="fa-solid fa-arrow-right-long"></i>'],
    dots: !1,
    responsive: {
        0: {
            items: 2
        },
        600: {
            items: 2
        },
        1024: { 
            items: 3
        }
    }
})

 $(".announcement-bar-slider").owlCarousel({
    items: 1,
    loop: !0,
    margin: 20,
    nav: !0,
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    dots: !1,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1024: {
            items: 1
        }
    }
})

 $(".recommended-collection-slider").owlCarousel({
    //items: 4,
    loop: !0,
    margin: 20,
    nav: !0,
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    dots: !1,
    responsive: {
        0: {
            items: 1.5
        },
        600: {
            items: 2
        },
        1024: {
            items: 4
        }
    }
})

  // Sync aria-expanded with collapse events for icon animation
  document.querySelectorAll('.collapse').forEach(function (collapseEl) {
    var btn = document.querySelector('[data-bs-target="#' + collapseEl.id + '"]');
    if (!btn) return;
    var icon = btn.querySelector('.faq-icon i');
    if (!icon) return;
    collapseEl.addEventListener('show.bs.collapse', function () {
      btn.setAttribute('aria-expanded', 'true');
      icon.className = 'bi bi-dash';
    });
    collapseEl.addEventListener('hide.bs.collapse', function () {
      btn.setAttribute('aria-expanded', 'false');
      icon.className = 'bi bi-plus';
    });
  });

var productMainSliderEl = document.querySelector('.product-main-slider');
var productThumbsEl = document.querySelector('.product-thumbnails');
if (productMainSliderEl && productThumbsEl && !document.body.classList.contains('template-product')) {
  var thumbSlideCount = productThumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
  // Loop mode creates cloned slides. Those clones become visible in the
  // desktop product grid, so keep the gallery aligned with Shopify media.
  var enableLoop = false;
  var thumbSpv = Math.max(1, Math.min(5, thumbSlideCount));

  // Vignettes en premier : le module `thumbs` de Swiper synchronise correctement le clic → slide principal
  var productThumbs = new Swiper(productThumbsEl, {
    slidesPerView: Math.min(3, thumbSpv),
    spaceBetween: 12,
    centeredSlides: false,
    loop: enableLoop,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: Math.min(5, thumbSpv),
        spaceBetween: 14
      }
    }
  });

  var mainSliderOptions = {
    slidesPerView: 1,
    centeredSlides: true,
    loop: enableLoop,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    thumbs: {
      swiper: productThumbs
    },
    navigation: {
      nextEl: productMainSliderEl.querySelector('.swiper-button-next'),
      prevEl: productMainSliderEl.querySelector('.swiper-button-prev')
    },
    pagination: {
      el: productMainSliderEl.querySelector('.swiper-pagination'),
      clickable: true
    }
  };
  if (enableLoop) {
    mainSliderOptions.loopedSlides = Math.min(thumbSlideCount, 10);
  }

  var productMainSlider = new Swiper(productMainSliderEl, mainSliderOptions);

  function refreshProductSwipers() {
    try {
      productThumbs.update();
      productMainSlider.update();
    } catch (e) {}
  }

  window.addEventListener('load', refreshProductSwipers, { once: true });
  window.addEventListener('resize', refreshProductSwipers);
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(function () {
      setTimeout(refreshProductSwipers, 50);
      setTimeout(refreshProductSwipers, 300);
    });
  }
}


var customToggleBtn = document.getElementById("customToggleBtn");
if (customToggleBtn) {
  customToggleBtn.addEventListener("click", function() {
    var toggler = document.querySelector(".navbar-toggler");
    if (toggler) toggler.click();
  });
}

 
  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('template-product')) {
      var main = document.getElementById('MainContent');
      if (main) {
        main.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.hero-section-content')) return;
    var tl = gsap.timeline({ defaults: { duration: 1, ease: 'power3.out' } });
    tl.from('.hero-section-content span', { y: 20, opacity: 0 });
    tl.from('.hero-section-content h2', { y: 50, opacity: 0 }, '-=0.5');
    tl.from('.all-btn-link-bg', { scale: 0, opacity: 0 }, '-=0.3');
    var heroImg = document.querySelector('.hero-image img');
    if (heroImg) tl.from(heroImg, { x: 100, opacity: 0 }, '-=0.8');
  });

  var heroBtn = document.querySelector('.all-btn-link-bg');
  if (heroBtn) {
    heroBtn.addEventListener('mouseenter', function () {
      gsap.to(heroBtn, { scale: 1.1, duration: 0.3 });
    });
    heroBtn.addEventListener('mouseleave', function () {
      gsap.to(heroBtn, { scale: 1, duration: 0.3 });
    });
  }
